import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import type { ContentfulCardFragment } from '@/graphql/contentful/api';

import {
  getContentAlignment,
  getTextAlignment,
  visibilityControl,
} from '../../Card.styles';

export const Wrapper = styled(Flex)<
  Pick<
    ContentfulCardFragment,
    | 'contentAlignment'
    | 'mediaAnimationEffect'
    | 'visibleInDesktop'
    | 'visibleInMobile'
  > & {
    $aspectRatio: string;
    $hasBackgroundImage: boolean;
  }
>`
  position: relative;
  overflow: hidden;

  ${({ $aspectRatio }) => css`
    aspect-ratio: ${$aspectRatio};
    .loaded > img,
    video {
      aspect-ratio: ${$aspectRatio};
    }
  `}
  ${({ visibleInDesktop, visibleInMobile }) => css`
    ${visibilityControl(visibleInDesktop, visibleInMobile)}
  `};
  ${({
    $hasBackgroundImage,
    contentAlignment,
    mediaAnimationEffect,
    theme,
  }) => css`
    ${mediaAnimationEffect &&
    css`
      &:hover {
        cursor: pointer;
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}

    padding: ${theme.spacing(8, 2)};
    color: ${$hasBackgroundImage ? theme.colors.white : theme.colors.black};

    ${theme.media.md.up} {
      padding: ${({ theme }) => theme.spacing(5)} 5%;
      ${getContentAlignment(contentAlignment)};
    }

    ${theme.media.lg.up} {
      padding-inline: 10%;
    }

    ${theme.media.md.down} {
      ${getContentAlignment(contentAlignment)}
    }
  `};
`;

export const Content = styled(Flex)<
  Pick<ContentfulCardFragment, 'textAlignment'>
>`
  flex-direction: column;
  max-width: 400px;
  word-break: break-word;
  white-space: pre-wrap;
  z-index: 2;

  ${({ textAlignment, theme }) => css`
    font-size: ${theme.fontSizes.p2};

    ${theme.media.md.down} {
      margin: 0 auto;
      ${getTextAlignment('Center')}
    }

    ${theme.media.md.up} {
      max-width: 500px;
      justify-content: center;
      ${getTextAlignment(textAlignment)}
    }

    ${theme.media.lg.up} {
      max-width: 550px;
      justify-content: center;
      ${getTextAlignment(textAlignment)}
    }
  `}
`;
